<template>
  <!-- 修复bug，如果type的类型不一样的时候，需要改变apiParams对象，否则会使用api-cache里的缓存，:api-params="{ type:props.commonApiSelectType }" -->
  <custom-api-select
    :api="getSelectorOptions"
    :immediate="!searchKey"
    :search-key="searchKey"
    value-field="value"
    label-field="label"
    :api-params="{ type:props.commonApiSelectType }"
  />
</template>
<script lang="ts" setup>
import { globalApi } from '@/api/global'
import { commonApiSelectProps } from './props'
type EmitEvents = {
  (e: 'selector-change', options: Recordable[]): void
}
const emits = defineEmits<EmitEvents>()

/* data 数据 */
const props = defineProps(commonApiSelectProps)

/* logics 逻辑 */

/* methods 方法 */
async function getSelectorOptions(otherApiParams) {
  // 因为 type 约束的是 ts 常量，是大写，而 api 传入的是小写，故需要转义成小写
  const apiParams = Object.assign({ type: props.commonApiSelectType }, otherApiParams)
  const result = await globalApi.getSelectorOptions({
    ...apiParams,
    ...props.elseApiParams
  })
  emits('selector-change', result as any)
  return result
}
</script>
